export const currencyFormat = {
    methods: {
        currency(number) {
            if (!number) return '--'
            var formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });

            return formatter.format(number);
        },
        currencyInvoice(number) {
            var formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return formatter.format(number);
        }
    }
};
